import { yupResolver } from '@hookform/resolvers/yup';
import { type Resolver } from 'react-hook-form';
import * as yup from 'yup';

export type Form = {
	idTramite: string;
	observaciones: string;
	observacionesPeticion?: string;
	observacionesSubsanacion?: string;
	observacionesEliminacion: string;
	isWrongFirma: string[];
	eliminarFirma: string[];
};

export const defaultValues = {
	idTramite: '',
	observaciones: '',
	observacionesPeticion: '',
	observacionesSubsanacion: '',
	observacionesEliminacion: '',
	isWrongFirma: [],
	eliminarFirma: []
};

export const schema = yup.object().shape({
	idTramite: yup.string(),
	observaciones: yup.string(),
	observacionesEliminacion: yup.string(),
});

export const getSchema = (): Resolver<any> => yupResolver(schema);